import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from 'dayjs';
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const outwardList = createAsyncThunk('outwardList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `stock_outward`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'department_id': data?.department_id || '',
                'location_id': data?.location_id || '',
                'component_id': data?.component_id || '',
                'equipment_id': data?.equipment_id || '',
                'outward_date': data.outwardDate && dayjs(data.outwardDate, 'DD/MM/YYYY').format('YYYY-MM-DD') || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const outwardListSlice = createSlice({
    name: 'outwardList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(outwardList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(outwardList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default outwardListSlice.reducer;